import { useEffect } from "react";

const APP_NAME = "Portal da Jornada do Cliente";

/**
 * Hook para definir o título da aba do navegador.
 *
 * Uso:
 *   usePageTitle("Documentos")  → "Documentos — Portal da Jornada do Cliente"
 *   usePageTitle()               → "Portal da Jornada do Cliente"
 *
 * Ao desmontar, restaura o título base.
 */
export function usePageTitle(pageTitle?: string) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} — ${APP_NAME}` : APP_NAME;

    return () => {
      document.title = APP_NAME;
    };
  }, [pageTitle]);
}

export { APP_NAME };
